export default {
    content: {
        class: [
            'tw-text-base tw-font-sans tw-text-black tw-text-lg',
            '[&_.ql-editor]:tw-min-h-80 [&_.ql-editor]:tw-max-h-96',
            '[&_.ql-editor_img]:tw-inline-block',
            '[&_.ql-editor:focus-visible]:tw-outline-none [&_.ql-editor:focus-visible]:tw-ring-2 [&_.ql-editor:focus-visible]:tw-ring-inset [&_.ql-editor:focus-visible]:tw-ring-primary-300',
        ],
    },
    toolbar: 'tw-hidden',
};
